import { DEFAULT_COUNTRY_ID } from './constants';
import { PersonalInformationWidgetData } from './types';
import { NetworkRequestState } from '../baseTypes';

const defaultPersonalInformationWidgetData: NonNullable<
  PersonalInformationWidgetData['initialData']
> = {
  pronoun: 'm',
  showPronoun: false,
  birthday: {
    canChange: false,
    dateOfBirth: '',
    display: 'none',
  },
  countryId: DEFAULT_COUNTRY_ID,
  countries: [],
  measurements: 'metric',
  canUpdateEmail: false,
};

export const defaultPersonalInformationWidgetState: PersonalInformationWidgetData =
  {
    initialData: defaultPersonalInformationWidgetData,
    currentData: defaultPersonalInformationWidgetData,
    isDirty: false,
    saveRequest: {
      status: NetworkRequestState.IDLE,
    },
  };
